  <!-- <div class="example-container" [class.example-is-mobile]="mobileQuery.matches">
    <mat-toolbar color="primary" class="example-toolbar">
      <button mat-icon-button (click)="snav.toggle()" *ngIf="mobileQuery.matches"><mat-icon>menu</mat-icon></button>
      <h1 class="example-app-name">Responsive App</h1>

      <span class="container" *ngIf="!mobileQuery.matches" > 
        <span class="item">
          <button mat-button class="mat-button-action" (click)="goto('/home')">
            <mat-icon class="fas fa-home"></mat-icon>
            &nbsp;Accueil
          </button>
          <button mat-button class="mat-button-action" (click)="goto('/quittances')">
            <mat-icon class="fas fa-trash"></mat-icon>
            &nbsp;Vos quittances
          </button>
          <button mat-button class="mat-button-action" (click)="goto('/doucumentContractuel')">
            <mat-icon class="far fa-calendar-alt"></mat-icon>
            &nbsp;Vos documents contractuels
          </button>
        </span>
        </span>
    </mat-toolbar>
  
    <mat-sidenav-container class="example-sidenav-container"
                           [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
      <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'"
                   [fixedInViewport]="mobileQuery.matches" fixedTopGap="56" color="primary" >
        <mat-nav-list>
          <a mat-list-item routerLink="../home" ><mat-icon class="fas fa-home"></mat-icon>&nbsp;Home</a> 
          <a mat-list-item routerLink="../quittances" ><mat-icon class="fas fa-trash"></mat-icon>&nbsp;Vos quittances</a> 
          <a mat-list-item routerLink="../doucumentContractuel" ><mat-icon class="far fa-calendar-alt"></mat-icon>&nbsp;Vos documents contractuels</a> 
        </mat-nav-list>
      </mat-sidenav>
  
      <mat-sidenav-content>
        <router-outlet></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div> -->
  <!-- <mat-toolbar >
    Toolbar
  </mat-toolbar>
  <mat-sidenav-container class="example-container">
    <mat-sidenav #sidenav mode="side" opened style="background-color:blue">
      Sidenav content</mat-sidenav>
    <mat-sidenav-content>
      <ng-content></ng-content>
      </mat-sidenav-content>
  </mat-sidenav-container> -->

 <mat-toolbar color="primary" >
	<button mat-icon-button (click)="isExpanded = !isExpanded"><mat-icon>menu</mat-icon></button>
	<h1 class="example-app-name">Receipt2Go</h1>
</mat-toolbar>
<mat-sidenav-container autosize >
	<mat-sidenav #sidenav  mode="side" opened="true" >
		<mat-nav-list> 
			<mat-list-item (click)="showSubmenu = !showSubmenu" class="parent" routerLink="../home" >
				<span class="full-width" *ngIf="isExpanded || isShowing">Accueil</span>
				<mat-icon mat-list-icon routerLink="../home">home</mat-icon>
				<!-- <mat-icon class="menu-button" [ngClass]="{'rotated' : showSubmenu}" *ngIf="isExpanded || isShowing">expand_more</mat-icon> -->
			</mat-list-item>
      <mat-list-item (click)="showSubmenu = !showSubmenu" class="parent" routerLink="../quittances">
				<span class="full-width" *ngIf="isExpanded || isShowing">Vos quittances</span>
				<mat-icon mat-list-icon routerLink="../quittances">description</mat-icon>
				<!-- <mat-icon class="menu-button" [ngClass]="{'rotated' : showSubmenu}" *ngIf="isExpanded || isShowing">expand_more</mat-icon> -->
			</mat-list-item>
      <mat-list-item (click)="showSubmenu = !showSubmenu" class="parent" routerLink="../doucumentContractuel" >
				<span class="full-width" *ngIf="isExpanded || isShowing">Vos documents contractuels</span>
				<mat-icon mat-list-icon routerLink="../doucumentContractuel">chrome_reader_mode</mat-icon>
				<!-- <mat-icon class="menu-button" [ngClass]="{'rotated' : showSubmenu}" *ngIf="isExpanded || isShowing">expand_more</mat-icon> -->
			</mat-list-item>
			<!-- <div class="submenu" [ngClass]="{'expanded' : showSubmenu}" *ngIf="isShowing || isExpanded">
				<a mat-list-item href="...">Submenu Item 1</a>
				<a mat-list-item href="...">Submenu Item 2</a>
				<mat-list-item (click)="showSubSubMenu = !showSubSubMenu" class="parent">
					<span class="full-width" *ngIf="isExpanded || isShowing">Nested Menu</span>
					<mat-icon class="menu-button" [ngClass]="{'rotated' : showSubSubMenu}" *ngIf="isExpanded || isShowing">expand_more</mat-icon>
				</mat-list-item>
				<div class="submenu" [ngClass]="{'expanded' : showSubSubMenu}" *ngIf="isShowing || isExpanded">
					<mat-list-item>SubSubmenu Item 1</mat-list-item>
					<mat-list-item>SubSubmenu Item 2</mat-list-item>
				</div>
			</div> -->
		</mat-nav-list>
    <!-- <mat-nav-list>
</mat-nav-list> -->
	</mat-sidenav>
  <router-outlet></router-outlet>

</mat-sidenav-container>



<!-- Copyright 2017 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->